export default __webpack_public_path__ + "static/media/mobile_77.54479b80.jpg";